import { useState } from 'react';
import { Share2 } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { copyTextToClipboard, type ClipboardCopyResult } from './clipboard';

const COPY_SHARE_LINK_LABEL = 'Copy share link for this page';
const SHARE_LINK_COPIED_LABEL = 'Share link copied!';
const CLIPBOARD_UNAVAILABLE_LABEL = 'Clipboard unavailable';
const COPY_FAILED_LABEL = 'Could not copy share link';

function getTooltip(copyResult: ClipboardCopyResult | null): string {
  switch (copyResult) {
    case 'copied':
      return SHARE_LINK_COPIED_LABEL;
    case 'unsupported':
      return CLIPBOARD_UNAVAILABLE_LABEL;
    case 'error':
      return COPY_FAILED_LABEL;
    default:
      return COPY_SHARE_LINK_LABEL;
  }
}

export function PageShareButton() {
  const location = useLocation();
  const [copyResult, setCopyResult] = useState<ClipboardCopyResult | null>(null);
  const tooltip = getTooltip(copyResult);

  async function handleCopy() {
    const shareUrl = `${window.location.origin}${location.pathname}${location.search}${location.hash}`;
    setCopyResult(await copyTextToClipboard(shareUrl));
  }

  function resetCopiedState() {
    setCopyResult(null);
  }

  return (
    <div
      className="group/share relative flex shrink-0 items-center"
      onMouseLeave={resetCopiedState}
      onBlur={resetCopiedState}
    >
      <button
        type="button"
        className="focus-ring inline-flex h-9 w-9 items-center justify-center rounded-full text-neutral-500 transition hover:bg-backoffice-50 hover:text-neutral-900"
        aria-label={COPY_SHARE_LINK_LABEL}
        title={tooltip}
        onClick={() => {
          void handleCopy();
        }}
      >
        <Share2 className="h-4 w-4" aria-hidden="true" />
      </button>
      <span className="pointer-events-none absolute bottom-full right-0 mb-2 hidden whitespace-nowrap rounded-md bg-neutral-900 px-2 py-1 text-[11px] font-medium text-white group-hover/share:block group-focus-within/share:block">
        {tooltip}
      </span>
    </div>
  );
}
